import {
  INVALID_ATTACHMENT_FILE_MESSAGE,
  MAX_RECORD_ATTACHMENTS,
  MAX_FILE_SIZE_BYTES,
  MAX_FILE_SIZE_MB,
} from '@/shared/config';
import { fileExtension, hasAllowedAttachmentExtension } from '@/shared/lib';

export const ATTACHMENT_TOO_LARGE_MESSAGE = `O arquivo ultrapassa ${MAX_FILE_SIZE_MB} MB. Escolha um arquivo menor.`;
export const ATTACHMENT_LIMIT_MESSAGE = `O Registro pode ter no máximo ${MAX_RECORD_ATTACHMENTS} anexos.`;

export interface AttachmentSelectionResult {
  accepted: File[];
  // One message per broken rule, in the order of the funnel, so a selection with five bad files
  // does not stack five equal toasts.
  refusals: string[];
}

// The browser shows only these in a tab; any other attachment is downloaded instead.
const BROWSER_VIEWABLE_EXTENSIONS: readonly string[] = ['.pdf', '.txt'];

export function opensInBrowser(fileName: string): boolean {
  return BROWSER_VIEWABLE_EXTENSIONS.includes(fileExtension(fileName.trim()));
}

/**
 * The funnel runs extension, then size, then count. The count judges what is left of the selection
 * as a whole: it either fits beside the `current` attachments or none of it goes.
 */
export function screenAttachmentSelection(
  files: readonly File[],
  current: number
): AttachmentSelectionResult {
  const refusals: string[] = [];
  // The record attachment server reads the extension of the trimmed name, while the document send
  // server reads the untrimmed one, so the shared check leaves the trim to each screen.
  const withExtension = files.filter((file) => hasAllowedAttachmentExtension(file.name.trim()));
  if (withExtension.length < files.length) refusals.push(INVALID_ATTACHMENT_FILE_MESSAGE);

  const withinSize = withExtension.filter((file) => file.size <= MAX_FILE_SIZE_BYTES);
  if (withinSize.length < withExtension.length) refusals.push(ATTACHMENT_TOO_LARGE_MESSAGE);

  if (withinSize.length > 0 && current + withinSize.length > MAX_RECORD_ATTACHMENTS) {
    return { accepted: [], refusals: [...refusals, ATTACHMENT_LIMIT_MESSAGE] };
  }

  return { accepted: withinSize, refusals };
}
